"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./");
const number_based_1 = require("../validators/number-based");
class NumberValidatorBuilderImpl extends _1.CommonValidatorBuilderImpl {
    constructor(validationRule) {
        super(validationRule);
    }
    buildRuleWith(validator) {
        this.validationRule.addValidator(validator);
        return this;
    }
    /*
     * =============================
     * Number-based validation rules
     * =============================
     */
    isPositive() {
        return this.buildRuleWith(new number_based_1.IsPositiveValidator());
    }
    isNegative() {
        return this.buildRuleWith(new number_based_1.IsNegativeValidator());
    }
    isGreaterThan(threshold) {
        return this.buildRuleWith(new number_based_1.IsGreaterThanValidator(threshold));
    }
    isGreaterThanOrEqual(threshold) {
        return this.buildRuleWith(new number_based_1.IsGreaterThanOrEqualToValidator(threshold));
    }
    isLessThan(threshold) {
        return this.buildRuleWith(new number_based_1.IsLessThanValidator(threshold));
    }
    isLessThanOrEqual(threshold) {
        return this.buildRuleWith(new number_based_1.IsLessThanOrEqualToValidator(threshold));
    }
}
exports.NumberValidatorBuilderImpl = NumberValidatorBuilderImpl;
//# sourceMappingURL=NumberValidatorBuilderImpl.js.map